import { observer } from "mobx-react-lite";
import { Button, Checkbox, Container, Form } from "semantic-ui-react";
import PageHeader from "../../../app/layout/PageHeader";
import { useTranslation } from "react-i18next";
import { useMemo, useState } from "react";

interface ImportDisclaimersProps {
  setConfirmed: React.Dispatch<React.SetStateAction<boolean>>
}

export default observer(function ImportDisclaimers(props: ImportDisclaimersProps) {
  const { t } = useTranslation(["imports"]);
  const disclaimers: string[] = t("disclaimers", { returnObjects: true });
  const [checks, setChecks] = useState<boolean[]>(disclaimers.map(() => false));

  const disabled = useMemo(() => {
    return checks.includes(false);
  }, [checks]);

  return (
    <Container className="page">
      <PageHeader
        header={t("confirmation")}
        type={"h3"}
        divider={false}
        getAlerts={false}
        addTitle={false}
      />
      <Form className="ui form" autoComplete="off">
          {disclaimers.map((disclaimer, index) => (
            <Form.Field key={`disclaimer_${index}`}>
                <Checkbox 
                  label={disclaimer}
                  onChange={(e, { checked }) => {
                    const updatedChecks = [...checks];
                    updatedChecks[index] = checked as boolean;
                    setChecks(updatedChecks);
                  }}
                />
            </Form.Field>
          ))}
          <Button color="green" 
            disabled={disabled}
            onClick={() => props.setConfirmed(true)}
          >
            {t('confirm')}
          </Button>
      </Form>
    </Container>
  );
});
